//import Moment from "moment";

const dataFormatada = (state) => {
    if (!state.departamento || !state.departamento.data) return null;
    return Moment(String(state.departamento.data)).format("DD/MM/YYYY");
}

const getCount = (state) => {
	return state.departamento.length;
}

export default {
    dataFormatada,
	getCount
}